import { cn } from "@genuin/ui/lib/utils";
import type { SVGIconsProps } from "../type";

export function RedditIcon({ className, ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={cn("gencl:fill-secondary-600", className)}
      {...restProps}
    >
      <g clipPath="url(#clip0_10019_58672)">
        <path
          d="M10 0C4.4775 0 0 4.4775 0 10C0 12.7617 1.11917 15.2617 2.92917 17.0708L1.02417 18.9758C0.645833 19.3542 0.914167 20 1.44833 20H10C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM13.6567 2.66583C14.5767 2.66583 15.3225 3.41167 15.3225 4.33167C15.3225 5.2525 14.5767 5.99833 13.6567 5.99833C12.8683 5.99833 12.2075 5.45083 12.0342 4.71583V4.7175C11.0783 4.8525 10.3408 5.67583 10.3408 6.66833V6.67417C11.8208 6.73 13.1742 7.14667 14.2458 7.81C14.64 7.5075 15.1325 7.32667 15.6683 7.32667C16.9575 7.32667 18.0033 8.37167 18.0033 9.66167C18.0033 10.5925 17.4575 11.3958 16.6692 11.7708C16.5958 14.4842 13.6383 16.6675 10.005 16.6675C6.37083 16.6675 3.4175 14.4867 3.34 11.7758C2.545 11.4033 1.995 10.5967 1.995 9.66083C1.995 8.37083 3.04083 7.32583 4.33083 7.32583C4.86833 7.32583 5.36333 7.5075 5.7575 7.81333C6.82 7.155 8.15833 6.7375 9.62417 6.67583V6.6675C9.62417 5.28167 10.6767 4.13917 12.0242 3.995C12.1808 3.23583 12.8517 2.66583 13.6567 2.66583ZM6.91917 9.64583C6.26583 9.64583 5.70333 10.2958 5.66417 11.1433C5.625 11.99 6.1975 12.3342 6.8525 12.3342C7.5075 12.3342 7.995 12.0267 8.03417 11.18C8.07333 10.3325 7.57333 9.64583 6.91917 9.64583ZM13.0908 9.64583C12.4358 9.64583 11.9367 10.3325 11.9758 11.18C12.015 12.0275 12.5042 12.3342 13.1575 12.3342C13.8117 12.3342 14.385 11.99 14.3458 11.1433C14.3075 10.2958 13.745 9.64583 13.0908 9.64583ZM10.005 12.99C9.19333 12.99 8.41583 13.03 7.69667 13.1025C7.57417 13.115 7.49583 13.2425 7.54417 13.3567C7.94667 14.3183 8.89583 14.9933 10.005 14.9933C11.1133 14.9933 12.0633 14.3183 12.4658 13.3567C12.5133 13.2425 12.435 13.115 12.3125 13.1025C11.5933 13.03 10.8167 12.99 10.005 12.99Z"
          fill="#767B81"
        />
      </g>
      <defs>
        <clipPath id="clip0_10019_58672">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
